<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  components: { ContentLoader },
  props: {
    animate: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<template>
  <content-loader
    width="1276"
    height="241"
    viewBox="0 0 1276 241"
    :speed="animate ? 2 : 0"
    primaryColor="#F9FAFF"
    secondaryColor="#D8DFF6"
    :primaryOpacity="0.9"
    :secondaryOpacity="0.25"
  >
    <rect x="92" y="25" width="51" height="29" rx="4" />
    <rect x="162" y="25" width="540" height="29" rx="4" />
    <rect x="713" y="25" width="219" height="29" rx="4" />
    <rect x="943" y="25" width="219" height="29" rx="4" />
    <rect x="92" y="66" width="51" height="29" rx="4" />
    <rect x="162" y="66" width="299" height="29" rx="4" />
    <rect x="473" y="66" width="299" height="29" rx="4" />
    <rect x="543" y="106" width="299" height="29" rx="4" />
    <rect x="782" y="66" width="299" height="29" rx="4" />
    <rect x="92" y="107" width="51" height="29" rx="4" />
    <rect x="162" y="107" width="267" height="29" rx="4" />
    <rect x="442" y="107" width="88" height="29" rx="4" />
    <rect x="92" y="148" width="51" height="29" rx="4" />
    <rect x="162" y="148" width="125" height="29" rx="4" />
    <rect x="296" y="148" width="125" height="29" rx="4" />
    <rect x="432" y="148" width="125" height="29" rx="4" />
    <rect x="92" y="189" width="51" height="29" rx="4" />
    <rect x="162" y="189" width="115" height="29" rx="4" />
    <rect x="287" y="189" width="69" height="29" rx="4" />
    <rect x="363" y="189" width="69" height="29" rx="4" />
  </content-loader>
</template>
